export const SLOT_NAMES = ['preview', 'live'];

export function preferredSlot(site) {
  const live = site?.slots?.live;
  return live?.version ? live : site?.slots?.preview || live || {};
}

export function domainsFor(site, slotName) {
  return site?.slots?.[slotName]?.domains || [];
}

export function allDomains(site) {
  return SLOT_NAMES.flatMap((slot) => domainsFor(site, slot));
}

export function domainName(entry) {
  return typeof entry === 'string' ? entry : entry?.domain;
}

export function liveDomain(site) {
  const live = site?.slots?.live;
  if (live?.url) return live.url.replace(/^https?:\/\//, '');
  const managed = domainsFor(site, 'live').find((entry) => entry?.managed);
  return domainName(managed || domainsFor(site, 'live')[0]);
}
